export const removeBasePath = (pathname: string) => {
  const basePath = process.env.PUBLIC_URL || '';
  if (!basePath) return pathname;
  
  const regex = new RegExp(`^${basePath}`);
  return pathname.replace(regex, '');
};